<div class="flex gap-4 w-full">
  <div class="flex flex-col w-full relative">
    @if (label) {
      <label
        [for]="id"
        class="ml-2 text-xs font-semibold text-lightText"
      >
        {{ label }}
      </label>
    }
    <input
      [id]="id"
      [name]="id"
      [type]="'email'"
      class="p-2 placeholder:text-sm rounded-xl placeholder:md:text-left focus:outline-none border"
      [style.border-color]="isValid ? '#9AA0A6' : '#E60012'"
      [placeholder]="placeholder || label || ''"
      [value]="value"
      (input)="inputHandler($event)"
      (blur)="blurHandler($event)"
    />
    @if (!isValid) {
      <span class="ml-2 text-xs text-toyotaRed font-semibold absolute top-[57px]">{{ errorMessage }}</span>
    }
  </div>

  @if (confirm) {
    <div class="flex flex-col">
      @if (label) {
        <label
          [for]="id"
          class="ml-2 text-xs font-semibold text-lightText"
        >
          {{ label }}
        </label>
      }
      <input
        [id]="id"
        [name]="id"
        [type]="'email'"
        class="p-2 placeholder:text-xs rounded-xl placeholder:md:text-left focus:outline-none border border-lighterGrey"
        [placeholder]="label || ''"
        [value]="confirmValue"
        (input)="inputHandler($event)"
        (blur)="blurHandler($event)"
      />
      <span class="ml-2 text-xs text-toyotaRed">{{ caption ?? '\u00A0' }}</span>
    </div>
  }
</div>
